import { createSelector } from '@ngrx/store';
import { AuthorizationsState } from '../reducers/authorizations.reducers';
import { selectUser } from './authentication.selectors';
import { SCHEDULED_SURGERY_ID, isScheduledSurgeryAllowed } from 'src/app/core/constants/authorizations';

const selectFeature = (state: any) => state.authorizations as AuthorizationsState;

export const selectauthorizationsMenu = createSelector(
  selectFeature,
  selectUser,
  (state: AuthorizationsState, affiliate: any) => {
    const authorizations = state.authorizationsType?.authorizations;

    if (!isScheduledSurgeryAllowed(affiliate?.provincia?.name)) {
      return authorizations?.filter((item: any) => item.id !== SCHEDULED_SURGERY_ID);
    }

    return authorizations;
  }
);

export const selectAuthorizationsHistory = createSelector(
  selectFeature,
  (state: AuthorizationsState) => state.authorizationsHistory?.authorizationsHistory
);
export const selectAuthorizationsHistoryLoading = createSelector(
  selectFeature,
  (state: AuthorizationsState) => state.authorizationsHistory?.isLoading
);
export const selectAuthorizationsNotification = createSelector(
  selectFeature,
  (state: AuthorizationsState) => state.authorizationsNotification?.authorizationsNotification
);
export const selectIdAuthorizations = createSelector(
  selectFeature,
  (state: AuthorizationsState) => state.active?.active.id
);
export const selectNameAuthorizations = createSelector(
  selectFeature,
  (state: AuthorizationsState) => state.active?.active?.label || state.active?.active
);

export const selectLabelAuthorizations = createSelector(
  selectFeature,
  (state: AuthorizationsState) => state.labelAuthorizations?.authorizations
);
export const selectLabelAuthorizationsLoading = createSelector(
  selectFeature,
  (state: AuthorizationsState) => !!state.labelAuthorizations?.isLoading
);
export const selectFirtsLabelAuthorizations = createSelector(
  selectFeature,
  (state: AuthorizationsState) => state.labelAuthorizations
);
export const selectFirtsHelpMessengerAuthorizations = createSelector(
  selectFeature,
  (state: AuthorizationsState) => state.labelAuthorizations?.payload?.notification
);

export const selectSecondLabelAuthorizations = createSelector(
  selectFeature,
  (state: AuthorizationsState) => state.secondLabelAuthorizations?.authorizations
);
export const selectSecondHelpMessengerAuthorizations = createSelector(
  selectFeature,
  (state: AuthorizationsState) => state.secondLabelAuthorizations?.payload?.notification
);
export const selectThirdLabelAuthorizations = createSelector(
  selectFeature,
  (state: AuthorizationsState) => state.thirdLabelAuthorizations?.authorizations
);

export const selectThirdHelpMessengerAuthorizations = createSelector(
  selectFeature,
  (state: AuthorizationsState) => state.thirdLabelAuthorizations?.payload?.notification
);
export const selectAuthorizationsForm = createSelector(
  selectFeature,
  (state: AuthorizationsState) => {
    return state.form?.form;
  }
);

export const selectAuthorizationsFormLoading = createSelector(
  selectFeature,
  (state: AuthorizationsState) => !!state.form?.loading
);

export const selectContentFormData = createSelector(selectFeature, (state: AuthorizationsState) => {
  return state.formData;
});

// El paso 4 (ubicación de retiro) lo define el back: aplica si la opción elegida en el último
// nivel (sin subopciones) viene con subsidiaryPickup. formData.groups solo guarda id y nombre,
// por eso la opción se busca en las listas de los tres selects.
export const selectHasWithdrawStep = createSelector(selectFeature, (state: AuthorizationsState) => {
  const groups = state.formData?.groups;
  if (!groups?.length) return false;

  const lastGroupId = Number(groups[groups.length - 1].id);
  const selected = [state.labelAuthorizations, state.secondLabelAuthorizations, state.thirdLabelAuthorizations]
    .flatMap(level => level?.authorizations ?? [])
    .find((option: any) => Number(option.id) === lastGroupId);

  return selected?.children === false && selected?.subsidiaryPickup === true;
});

export const selectScheduledSurgery = createSelector(selectFeature, (state: AuthorizationsState) => {
  return state.active?.active?.id === SCHEDULED_SURGERY_ID;
});

export const selectSurgeryMaterialsSelected = createSelector(selectFeature, (state: AuthorizationsState) => {
  if (!state.formData?.groups?.length) {
    return false;
  }
  return state.formData.groups.some(group => {
    const name = group.name?.toLowerCase();
    return name === 'si' || name?.includes('tiene pedido de materiales: si');
  });
});
